import { Offering } from '@arrived/models';

import { canOfferingStatusReserveShares } from '../canOfferingStatusReserveShares';

export const getInvestorsCount = (offering: Offering): number => {
  const { investorsCount, reservedInvestorsCount, status } = offering;

  return canOfferingStatusReserveShares(status) ? reservedInvestorsCount : investorsCount;
};
